import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class DocumentService {
	constructor(private http: HttpClient) { }


	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:get',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	defaut(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:defaut',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	listbydossier(id: any, options: any = []) {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:getbydossier',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(documents: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:set',
			params: {
				documents: documents,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	uploadDocument(file: File): Observable<JSONRpcResponse> {
		let testData: FormData = new FormData()
		testData.append('id_send',this.newGuid())
		testData.append('file_upload', environment.tokenauth)
		testData.append('file_upload', file, file.name)

		return this.http.post<JSONRpc>(environment.webservice + 'upload', testData)
	}
	
	newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8)
			return v.toString(16)
		})
	}

	getDocumentsType(demandeType: string = 'DOSSIER'): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:defaut',
			params: {
				options: {
					demande_type: demandeType
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setDocumentByInstruction(demandeid: any, document: any, dossier: any = 0, demande_type: string = 'DOSSIER',visite:number=0,consultation:number=0): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:set',
			params: {
				documents: [document],
				options: {
					demande: demandeid,
					dossier: dossier,
				/*	demande_type: demande_type*/
				},
			},
		})
		if (demandeid == 0) {
			rpcMethod.params.options.dossier = dossier
			rpcMethod.params.options.demande_type = demande_type
		}
		
		if (visite>0) {
					rpcMethod.params.options.visite = visite		
		}
		if (consultation>0) {
							rpcMethod.params.options.consultation = consultation		
		}
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setDocumentEtat(demandedocumentid: number, etat: number): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:etat',
			params: {
				id: demandedocumentid,
				etat: etat,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	setDocumentDelete(demandedocumentid: number): Observable<JSONRpcResponse> {
		return this.setDocumentEtat(demandedocumentid, 0)
	}

	setDocumentRestore(demandedocumentid: number): Observable<JSONRpcResponse> {
		return this.setDocumentEtat(demandedocumentid, 1)
	}

	getFormulairesByDocument(documentid: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:formulaires',
			params: {
				id: documentid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	getInterventionsByDocument(documentid: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:interventions',
			params: {
				id: documentid,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    joinDocumentAtFormulaire(id: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:demandeDocumentFormulaire',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    removeDocumentAtFormulaire(id: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:removeDocumentAtFormulaire',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    getDocumentsAtFormulaire(id: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:getDocumentsAtFormulaire',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    getFormulairesAtDocument(id: number, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:getFormulairesAtDocument',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getListDocumentsForInstruction(instructionid: any): Observable<any> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.document:list',
			params: {
				options: {
					instruction: instructionid,
				},
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	
	getListDocumentsTemp(options: any = []): Observable<any> {
			let rpcMethod = new JSONRpc({
				jsonrpc: '2.0',
				method: 'webservice.document:gettempfiles',
				params: {
					options: options
				}
			})
			return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	

}
